var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-container building-container",
      class: { rotated: _vm.animationStarted }
    },
    [
      _c(
        "div",
        { staticClass: "wtw-container small text-center" },
        [
          _c("logo", { staticClass: "logo-large" }),
          _vm._v(" "),
          _c("div", { staticClass: "account-complete-video" }, [
            _c("img", {
              attrs: { src: _vm.imageUrl("account-complete-animation.gif") }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wtw-container building-text-container" },
            [
              _c(
                "transition-group",
                { attrs: { name: "fade-slow-up", mode: "out-in" } },
                [
                  _vm.animationStarted && !_vm.animationComplete
                    ? _c("div", { key: "1", staticClass: "building-text" }, [
                        _vm._v(
                          "\n                        Thank You. We are now building a custom shopping experience just for you!\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.animationComplete
                    ? _c("div", { key: "2", staticClass: "building-text" }, [
                        _vm._v(
                          "\n                        Your Account is Ready! Loading your account now....\n                    "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-330c6a4d", { render: render, staticRenderFns: staticRenderFns })
  }
}